import { render, staticRenderFns } from "./TrackerFolder.vue?vue&type=template&id=0f41afba&scoped=true&"
import script from "./TrackerFolder.vue?vue&type=script&lang=js&"
export * from "./TrackerFolder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f41afba",
  null
  
)

export default component.exports